// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Driveline overrides loaded after lumo.css in the webpack bundle so they win in cascade.
 */

:root {
  --vaadin-input-field-autofill-background: #daecff;
  --vaadin-input-field-autofill-color: black;
}

vaadin-text-field:has(> input[slot='input']:autofill)::part(input-field),
vaadin-password-field:has(> input[slot='input']:autofill)::part(input-field) {
  --vaadin-input-field-background: var(--vaadin-input-field-autofill-background, #daecff) !important;
  --vaadin-input-field-value-color: var(--vaadin-input-field-autofill-color, black) !important;
  --vaadin-input-field-button-text-color: var(--vaadin-input-field-autofill-color, black) !important;
}
`, "",{"version":3,"sources":["webpack://./src/vaadin-lumo-overrides.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;EAEE,kGAAkG;EAClG,4FAA4F;EAC5F,kGAAkG;AACpG","sourcesContent":["/**\n * Driveline overrides loaded after lumo.css in the webpack bundle so they win in cascade.\n */\n\n:root {\n  --vaadin-input-field-autofill-background: #daecff;\n  --vaadin-input-field-autofill-color: black;\n}\n\nvaadin-text-field:has(> input[slot='input']:autofill)::part(input-field),\nvaadin-password-field:has(> input[slot='input']:autofill)::part(input-field) {\n  --vaadin-input-field-background: var(--vaadin-input-field-autofill-background, #daecff) !important;\n  --vaadin-input-field-value-color: var(--vaadin-input-field-autofill-color, black) !important;\n  --vaadin-input-field-button-text-color: var(--vaadin-input-field-autofill-color, black) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
